export enum ListingStatus {
	None = 0,
	Draft = 1,
	Active = 2,
	Inactive = 3,
	Approved = 4,
	Rejected = 5,
	InReview = 6
}
